// extracted by mini-css-extract-plugin
export default {"bubble":"_3wsvG","content":"_3wfI5","triangleWrapper":"_1qZT5","arrowleft":"_2hlMo","triangle":"hoLcd"};